export const PackageConditionValues = {
    DEBT: "DEBT",
    UNSUBMITTED_REPORTS: "UNSUBMITTED_REPORTS",
    UNSYNCED: "UNSYNCED",
    LAST_TEST_HAS_COMMENT: "LAST_TEST_HAS_COMMENT",
    LAST_TEST_HAS_STANDARD_COMMENT: "LAST_TEST_HAS_STANDARD_COMMENT"
};
